import { render, staticRenderFns } from "./contact-im.vue?vue&type=template&id=0f145028&scoped=true&"
import script from "./contact-im.vue?vue&type=script&lang=js&"
export * from "./contact-im.vue?vue&type=script&lang=js&"
import style0 from "./contact-im.vue?vue&type=style&index=0&id=0f145028&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f145028",
  null
  
)

export default component.exports